var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools"},[_vm._v(" tools ")])
}
var staticRenderFns = []

export { render, staticRenderFns }